@if (isCompetitionLogo()) {
    <ms-competition-logo
        class="icon"
        [sportId]="eventCarouselItem().event.sport.id"
        [leagueId]="eventCarouselItem().event.league.parentLeagueId ?? eventCarouselItem().event.league.id"
        [fallbackIcon]="headerIcon()" />
} @else if (headerIcon()) {
    <span [class]="headerIcon()"></span>
}
<div class="title">{{ eventCarouselItem().titleData?.title }}</div>
